import { useTranslation } from 'react-i18next';

export default function SafetySection() {
  const { t } = useTranslation();

  const checks = [
    { icon: 'ri-image-line', label: t('safety.check1'), desc: t('safety.check1Desc') },
    { icon: 'ri-chat-3-line', label: t('safety.check2'), desc: t('safety.check2Desc') },
    { icon: 'ri-money-dollar-circle-line', label: t('safety.check3'), desc: t('safety.check3Desc') },
    { icon: 'ri-user-settings-line', label: t('safety.check4'), desc: t('safety.check4Desc') },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-5">
            {t('safety.title')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            {t('safety.desc')}
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-accent-50">
                <th className="text-left px-5 py-4 font-semibold text-foreground-900">{t('comparison.feature')}</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-700">{t('safety.check1Desc').split(' ').slice(0, 1).join(' ')}</th>
              </tr>
            </thead>
            <tbody>
              {checks.map((check, i) => (
                <tr key={i} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-3.5">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className={`${check.icon} text-accent-600 text-sm`}></i>
                      </div>
                      <span className="font-medium text-foreground-900">{check.label}</span>
                    </div>
                  </td>
                  <td className="px-5 py-3.5 text-foreground-500">{check.desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}